import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../../../common/types/RecordType";
import { useCloudAssetDetails } from "../../../common/hooks/useCloudAssetDetails";
import { CloudAudioTechnicalSection } from "./audio/CloudAudioTechnicalSection";
import { CloudVideoTechnicalSection } from "./video/CloudVideoTechnicalSection";

export const CloudTechnicalSection = (): JSX.Element => {
    const { isLoading, data: assetDetails } = useCloudAssetDetails();

    switch (assetDetails?.type) {
        case RecordType.Video:
            return (
                <CloudVideoTechnicalSection
                    technical={assetDetails.technical}
                    isLoading={isLoading}
                    style={{ height: 450 }}
                />
            );

        case RecordType.Audio:
            return (
                <CloudAudioTechnicalSection
                    technical={assetDetails.technical}
                    isLoading={isLoading}
                    style={{ height: 450 }}
                />
            );

        case RecordType.Subtitle:
            return <></>;

        default:
            return <ContentSection header="Technical" isLoading={true} style={{ height: 450 }} />;
    }
};
